import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📊 Q2 2019 Design Systems survey results`}</h2>
    <p>{`Overall, the results from this survey align with the amount of work we’ve done for each platform. Web scored highest, iOS came in second, and Android was third.`}</p>
    <p>{`As we continue shifting focus towards Thumbprint Native, two results stand out:`}</p>
    <ul>
      <li parentName="ul">{`We’ve been able to build ~9 components on iOS (thanks to contributions from iOS engineers) but 0 on Android. This progress is reflected in:`}<ul parentName="li">
          <li parentName="ul">{`Higher scores on both the Net Promoter Score and Productivity questions for iOS.`}</li>
          <li parentName="ul">{`In comments for the Productivity question, 6 of 7 Android responses mention that nothing new has made them more productive. No iOS engineers made this point.`}</li>
        </ul></li>
      <li parentName="ul">{`The response from web engineers continues to be overwhelmingly positive. This quarter we saw the highest scores ever in both the Net Promoter Score question and Confidence question.`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "https://docs.google.com/document/d/1PnedmfvVF3pUIyz73rm78FeXQsOUh5VUMWk0gPewQW4/edit"
      }}>{`Full results and raw data`}</a>{` are available if you’d like to know more. Thank you to all the engineers that participated.`}</p>
    <h2>{`📱 Native`}</h2>
    <ul>
      <li parentName="ul">{`Thumbprint Tokens are now `}<a parentName="li" {...{
          "href": "https://cocoapods.org/pods/ThumbprintTokens"
        }}>{`published to CocoaPods`}</a>{` and `}<a parentName="li" {...{
          "href": "https://thumbprint.design/"
        }}>{`documented on thumbprint.design`}</a>{`. (Daniel O.)`}</li>
      <li parentName="ul">{`Design work on Layouts, Cards & Carousels, Bottom Navigation, and Headers are getting underway. (Jon K.)`}</li>
      <li parentName="ul">{`The first PR for an iOS Avatar component has been merged. A follow-up PR will add an online indicator. (Santi G.)`}</li>
      <li parentName="ul">{`A PR was created for a Pill component on iOS. (Daniel S.)`}</li>
      <li parentName="ul">{`The Android Avatar component will be ready for code review in a few days. (Luke B.)`}</li>
      <li parentName="ul">{`We’re `}<a parentName="li" {...{
          "href": "https://github.com/thumbtack/thumbprint/pull/371"
        }}>{`beginning to explore native component documentation`}</a>{` on thumbprint.design. (Luke B.)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/thumbtack/thumbprint/pull/374"
        }}>{`Thumbprint Tokens for Android`}</a>{` is in progress. (Daniel O.)`}</li>
    </ul>
    <h2>{`🍭 Design`}</h2>
    <ul>
      <li parentName="ul">{`A Framer X prototype to help customers compare Pros is in the works. (Tom G.)`}</li>
      <li parentName="ul">{`Designs for Avatars, Title Frame, and Shadows are in the works (Jon K.)`}</li>
    </ul>
    <h2>{`🖥 Web`}</h2>
    <ul>
      <li parentName="ul">{`The default fade-in animation was removed from the `}<inlineCode parentName="li">{`Image`}</inlineCode>{` component. (Tom G.)`}</li>
      <li parentName="ul">{`We’ve refactored the internals of modals, tooltips, and popovers to share code for common functionality. (Giles L.)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      